import formatPhoneNumber from '../../../utils/formatPhone';

export function matchTextsToPax(newTexts, pax) {
  let output = [];
  for (let i = 0; i < newTexts.length; i++) {
    let phone = formatPhoneNumber(newTexts[i].sender);
    if (newTexts[i].rloc.toLowerCase() === pax.PNRRefNo.toLowerCase() && phone === pax.phone) {
      output.push(newTexts[i]);
    };
  };
  return output;
}